import * as React from "react";
import * as Scrivito from "scrivito";
import { getPageLink } from "utils/getPageLink";
import cx from "classnames";
import type { IconName } from "./iconNames";

import s from "./Icon.module.scss";

const SVG_SPRITE_PATH = "/icons/svg-sprite/svg-sprite.svg";

type IconProps = Omit<React.SVGProps<SVGSVGElement>, "className"> & {
  iconName?: IconName;
  link?: Scrivito.Link | Scrivito.Obj;
  title?: string;
  className?: string;
  id?: string;
  onClick?: (e: React.MouseEvent<SVGElement>) => void;
  tabIndex?: number;
  color?: string;
  style?: React.CSSProperties;
  "data-testid"?: string;
};

const getLinkTitle = (link?: Scrivito.Link | Scrivito.Obj): string | null => {
  if (!link) return null;
  if (typeof (link as { title?: unknown }).title === "function") {
    return (link as { title: () => string | null | undefined }).title() ?? null;
  }
  return null;
};

const IconComp = Scrivito.connect(
  ({
    iconName = "star-light",
    link,
    title,
    className = "icon-16",
    ...rest
  }: IconProps) => {
    const linkTitle = getLinkTitle(link);
    const titleProp = title || linkTitle || undefined;
    const isDefaultSize = !!className?.match(/icon-/g)?.length;

    const icon = (
      <svg
        className={cx("svg-inline--fa", s.svg, s.outlineNone, className, {
          "icon-16": !isDefaultSize,
        })}
        {...rest}
      >
        {titleProp && <title>{titleProp}</title>}
        <use href={`${SVG_SPRITE_PATH}#${iconName}`} />
      </svg>
    );

    if (!link) return icon;

    return (
      <Scrivito.LinkTag to={getPageLink(link) || null}>{icon}</Scrivito.LinkTag>
    );
  },
);

export const Icon = React.memo(IconComp);
